import { chakra, Spinner } from '@chakra-ui/react';

export const TableCounterBox = (props: {
  isLoading: boolean;
  count: number;
  label: string;
}) => {
  return props.isLoading
    ? <Spinner hideBelow='sm' color='fg.subtle' size='md' ml='4' />
    : <chakra.span fontSize='sm' color='fg.muted'>
      <chakra.span>{props.count}</chakra.span>
      <chakra.span hideBelow='sm' marginLeft={1}>{props.label}</chakra.span>
    </chakra.span>
}